<template>
   <div class="contant" v-title="pageTitle"> 
       <div> 
        <van-tabs sticky @change="change">
             <van-tab v-for="(items,index) in tabs" :title="items" :key="index">
                <!-- 内容 {{ index }} -->
                <!-- <van-empty image="error" v-if="list.length==0" description="暂无数据" /> -->
                <van-loading size="24px" v-if="loading"  vertical style="padding-top: 300px;">加载中...</van-loading>
                <div class="empty" v-if="list.length==0&&!loading">暂无数据</div>
                <div v-for="(items,index) in list" :key="index" class="in_"> 
            <div class="cont sz" @click.stop="to_details(index)"> 
                <!-- 订单号 -->
                <div class="flx"> 
                     <div style="width: 18%;text-align: left;" @click.stop="copy(index)">订单号: </div>
                     <div style="width: 60%;text-align: left;" @click.stop="copy(index)">{{ items.orderSn }}</div>
                     <div style="width: 18%;text-align: center;margin-right: 10px;" :class="items.orderStatus == 203 ? 'sz_ s0' : '' ||items.orderStatus == 202 ? 'sz_ s3' : ''|| items.orderStatus == 201 ? 'sz_ s2' : '' || (items.orderStatus == 201 || items.orderStatus == 301 || items.orderStatus == 401 || items.orderStatus == 402) ? 'sz_ s1' : '' || (items.orderStatus == 101 || items.orderStatus == 102 || items.orderStatus == 103 || items.orderStatus == 204) ? 'sz_ s4' : ''">{{statusReturn(items.orderStatus)}}</div>
                     <!-- <div class="line"></div>
                     <van-icon style="margin-left: 2%;" name="delete" /> -->
                </div>
                <div class="line_"></div>
                <div> 
                    <div v-for="(itm, idx) in items.goodsVoList" :key="idx">
                                <div class="flx_"> 
                            <div><img :src="itm.picUrl" class="imgurl" /></div>
                            <div style="margin-left: 10px;width: 60%;">
                                <div style="text-align: left">{{ itm.goodsName }}</div>
                                <div style="text-align: left;font-size: 13px;color: #8e8d8d;margin-top: 5px;">{{ itm.specifications.toString() }}</div>
                                <div style="text-align: left;margin-top: 10px;">¥ {{ itm.price }}</div>
                            </div>   
                            <div>X{{ itm.number }}</div>
                            </div>
                            <div class="line_"></div>
                        </div>
                </div>
                 <div class="down_">订单价格 ¥ {{ items.actualPrice }}</div>
            </div>
       </div>
            </van-tab>
       </van-tabs>
       </div>
       <div style="padding-top: 10px;padding-bottom: 20px;" v-if="total>10"> 
           <van-pagination v-model="currentPage" :total-items="total" :items-per-page="per" @change="pagesChange" />
       </div>
      
  
</div>
</template>

<script>
import request from '../api/request'
import damo from '../api/test'
export default {
    data(){
        return{
         list:[],pageTitle:'订单管理',containerHeight: 0,currentPage: 1,total:0,per:10,loading:true,
         innerHeight:0,tabs:['全部','已付款','已发货','申请退款','已退款','用户取消','系统取消','待付款','用户收货','系统收货'],
         
        }
    },
    mounted(){
     this.loading=true
     this.loaddata()
    },
    methods:{
        loaddata(){
            request.getcommerlist({orderStatusArray:'',page:this.currentPage},'/admin/order/list','get',localStorage.getItem('token_yr'),res=>{
                console.log(res)
                if(res.errno==0){
                    this.firstData=res.data.list
                    this.total=JSON.parse(JSON.stringify(this.firstData))
                    this.loadlist()
                }
                this.loading=false
            })
        },
        loadlist(){
            this.list=JSON.parse(JSON.stringify(this.firstData))
            this.list=this.list.slice((this.currentPage-1)*10,this.currentPage*10)
        },
        change(index){
            this.currentPage=1
            const list=JSON.parse(JSON.stringify(this.firstData))
            if(index==0) {
                this.total=JSON.parse(JSON.stringify(this.firstData)).length
                this.loadlist()
            }
            else {
                this.list=list.filter(item=>{return item.orderStatus==this.nameReturn(this.tabs[index])})
                this.total=JSON.parse(JSON.stringify(list))
                this.list=this.list.slice((this.currentPage-1)*10,this.currentPage*10)
            }
        },
        pagesChange(e){
            this.currentPage=e
            this.loadlist()
            console.log(e)
        },
        to_details(e){
            console.log(this.list[e])
            localStorage.setItem('details_id',this.list[e].id)
            this.$router.push({ path: '/order_details', query: {} })
        },
        copy(e) {
            this.$copyText('订单号: '+ this.list[e].orderSn).then(() => {
                this.$toast("成功复制！")
            }).catch(() => {
                this.$toast("复制失败")
            })
        },
       //状态
       nameReturn(e){
        switch(e){
            case '待付款':
            return 101
            break;
            case '用户取消':
            return 102
            break;
            case '系统取消':
            return 103
            break;
            case '已付款':
            return 201
            break;
            case '申请退款':
            return 202
            break;
            case '已退款':
            return 203
            break;
            case '已发货':
            return 301
            break;
            case '用户收货':
            return 401
            break;
            case '系统收货':
            return 402
            break;
        }
       },
       statusReturn(e){
        switch(e){
            case 101:
            return '待付款'
            break;
            case 102:
            return '用户取消'
            break;
            case 103:
            return '系统取消'
            break;
            case 201:
            return '已付款'
            break;
            case 202:
            return '申请退款'
            break;
            case 203:
            return '已退款'
            break;
            case 301:
            return '已发货'
            break;
            case 401:
            return '用户收货'
            break;
            case 402:
            return '系统收货'
            break;
        }
       }
    },
    

}
</script>

<style lang="less" scoped>
 .contant{
    background: #efefef;
    height: 100%;
    width: 100%;
    overflow: scroll;
 }
 .in_{padding-top: 5px;padding-left: 5px;padding-right: 5px;}
 .cont{padding: 10px; background: #fff;border-radius: 5px;}
 .flx{display: flex;align-items: center;}
 .flx_{display: flex;}
 .sz{font-size: 14px;}
 .line{width: 1px;height: 15px;background: #dbdada;}
 .line_{width: 100%;height: 1px;background: #f2f0f0;margin-top: 8px;margin-bottom: 8px;}
 .imgurl{width: 100px;height: auto;border-radius: 5px;}
 .title{display: flex; justify-content: space-between;}
 .down_{font-size: 15px;  text-align: right;}
 .empty{width: 100%;text-align: center;margin-top: 55%;color: #959494;font-size: 15px;}
 .s0 {
    color: red;
    padding: 2px;
    background: #fab2b2;
    border: #f84e4e solid 1px;
    border-radius: 5px;
    font-size: 12px;
}

.s1 {
    color: rgb(68, 0, 255);
    padding: 2px;
    background: #a7acfb;
    border: #345cfb solid 1px;
    border-radius: 5px;
    font-size: 12px;
}

.s2 {
    color: rgb(18, 176, 55);
    padding: 2px;
    background: #c1fba7;
    border: #48fd3b solid 1px;
    border-radius: 5px;
    font-size: 12px;
}

.s3 {
    color: #fdc33b;
    padding: 2px;
    background: #f6f3c3;
    border: #fdc33b solid 1px;
    border-radius: 5px;
    font-size: 12px;
}
.s4 {
    color: #6d6d6c;
    padding: 2px;
    background: #d4d4d3;
    border: #999998 solid 1px;
    border-radius: 5px;
    font-size: 12px;
}
</style>